import {
  fetchAll,
  createDocWithId,
  updateDocById,
  uuidv4,
} from "./firestoreHelpers";

const COLL = "actividad";

// Each entry: { idFirebase, tipo, mensaje, entidadTipo, entidadId, entidadLabel,
//   monto, moneda, autorUid, autorNombre, leidoPor (array de uids), createdAt }
export const getActividad = async () => fetchAll(COLL);

// Arma el registro completo del lado del cliente para pintarlo antes de que
// Firestore confirme la escritura (igual que nuevaNota en notas.js).
export const nuevaActividad = (data) => ({
  ...data,
  idFirebase: uuidv4(),
  leidoPor: [],
  createdAt: new Date().toISOString(),
});

export const saveActividad = async (actividad) =>
  createDocWithId(COLL, actividad, actividad.idFirebase);

export const marcarLeidaActividad = async (id, leidoPor) =>
  updateDocById(COLL, id, { leidoPor });
